

<div mat-dialog-content>
    <span class="logo-pelecard"></span>

    <div align="center" style="font-size: 18px;">       
        <div>{{ 'PAYMENT.JOIN-PELECARD-MSG' | translate  }}</div>
        <div><a class="title-color" href="https://www.pelecard.com" target="_blank">https://www.pelecard.com</a></div>
        <div class="title-color">03-6579500</div>
    </div>
</div>
  
  
<div mat-dialog-actions align="center">    
    <button mat-raised-button color="primary" class="w-100" cdkFocusInitial (click)="onClose($event)">{{ 'COMMON.OK' | translate }}</button>
</div> 
